import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import {
    BaasicTable,
    TableFilter,
    EmptyState,
    BaasicModal,
    BaasicButton
} from "core/components";
import { ApplicationListLayout, Content, PageNavigation } from "core/layouts";
import { ConfirmingReportItemPreviewModal, ConfirmingReportItemValidationsModal } from "application/confirming-report/components";

const ConfirmingReportItemListTemplate = function({ confirmingReportItemListViewStore }) {
    
    const { tableStore, routes, queryUtility, authorization, confirmingReportItemPreviewModal, confirmingReportItemValidationsModal, rootStore } = confirmingReportItemListViewStore;

    return (
        <ApplicationListLayout
            store={confirmingReportItemListViewStore}
            authorization={authorization}
        >
            <PageNavigation>
                <BaasicButton 
                    type='button'
                    className="btn btn--base btn--primary"
                    onClick={() => routes.pumpAndPoleItems() }
                    label={("CONFIRMING_REPORT_ITEM.PUMP_AND_POLES.BUTTON.LABEL")}
                />
                <BaasicButton 
                    type='button'
                    className="btn btn--base btn--primary"
                    onClick={() => routes.specificConfirmingStatusItems() }
                    label={('CONFIRMING_REPORT_ITEM.CONFIRMING_STATUS.BUTTON.LABEL')}
                />
                <BaasicButton 
                    type='button'
                    className="btn btn--base btn--ghost"
                    icon='u-icon u-icon--xsml u-icon--btn-back'
                    onClick={() => rootStore.routerStore.goBack() }
                    label={('LIST_LAYOUT.BACK_BUTTON')}
                />
            </PageNavigation>
            <Content emptyRenderer={renderEmpty(routes)}>
                <div className="row u-mar--bottom--sml">
                    <div className="col col-lrg-6">
                        <TableFilter queryUtility={queryUtility}></TableFilter>
                    </div>
                </div>
                <div className="card--table">
                    <BaasicTable
                        authorization={authorization}
                        tableStore={tableStore}
                    />
                </div>
                <BaasicModal modalParams={confirmingReportItemPreviewModal} className="modal__content ReactModal__Content--large">
                    <ConfirmingReportItemPreviewModal />
                </BaasicModal>
                <BaasicModal modalParams={confirmingReportItemValidationsModal} className="modal__content ReactModal__Content--large">
                    <ConfirmingReportItemValidationsModal />
                </BaasicModal>
            </Content>

        </ApplicationListLayout>
    );
};

function renderEmpty(routes) {
    return (
        <EmptyState
            title="CONFIRMING_REPORT_ITEM.LIST.EMPTY_STATE.TITLE"
            callToAction={routes.create}
        />
    );
}

ConfirmingReportItemListTemplate.propTypes = {
    confirmingReportItemListViewStore: PropTypes.object.isRequired
};

export default defaultTemplate(ConfirmingReportItemListTemplate);